export default __webpack_public_path__ + "static/media/sketch07.660ce26b.png";